/**
 * @file Contém as constantes do sistema
 */
const sistema = {
        DATA_INICIO_CADASTROS: '29/07/2021',        
}
export default sistema;
